/**
 * Séparation et déduplication des sorties IA pour la synthèse / rapport.
 *
 * - GEO (positionnement) : visibilité dans les LLM, pages de référence
 * - SEO (ai-recommendations) : constats mesurés sur le crawl, actions classiques
 */

function normText(s) {
  return (s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

function textsSimilar(a, b) {
  const na = normText(a);
  const nb = normText(b);
  if (!na || !nb) return false;
  if (na === nb) return true;
  if (na.length > 24 && nb.length > 24 && (na.includes(nb) || nb.includes(na))) return true;
  return false;
}

function itemText(item) {
  if (item == null) return '';
  if (typeof item === 'string') return item;
  return item.title || item.tache || item.description || item.action || '';
}

/** Extrait le bloc GEO depuis une analyse de positionnement API. */
export function extractGeoInsights(positioning) {
  if (!positioning) {
    return {
      scoreGlobalGeo: null,
      pointsForts: [],
      pointsFaibles: [],
      todos: [],
      alertes: [],
      hasData: false,
    };
  }
  const raw = positioning.raw_json || {};
  const geoScore = raw.geo_score || {};
  const todos = (positioning.todo_list || []).slice(0, 8);

  return {
    scoreGlobalGeo: geoScore.score_global_geo ?? positioning.score_positionnement ?? null,
    pointsForts: positioning.points_forts || [],
    pointsFaibles: positioning.points_faibles || [],
    todos,
    alertes: (geoScore.alertes_prioritaires || []).slice(0, 5),
    hasData: Boolean(
      (positioning.points_forts?.length)
      || (positioning.points_faibles?.length)
      || todos.length
      || geoScore.score_global_geo,
    ),
  };
}

/**
 * Recommandations SEO projet, dédupliquées par rapport aux textes GEO déjà affichés.
 */
export function extractSeoRecommendations(aiRecommendations, geoTexts = []) {
  if (!aiRecommendations) {
    return { summary: '', priorityRecos: [], hasData: false };
  }
  const geoNorm = geoTexts.map(itemText).filter(Boolean);
  const priority = (aiRecommendations.priority_recommendations || []).filter((reco) => {
    const t = itemText(reco);
    return t && !geoNorm.some((g) => textsSimilar(g, t));
  });

  return {
    summary: aiRecommendations.summary || '',
    priorityRecos: priority.slice(0, 6),
    hasData: Boolean(priority.length || aiRecommendations.summary),
  };
}

/** Textes GEO pour déduplication (points + todos + alertes). */
export function geoTextsForDedupe(geo) {
  const out = [];
  for (const p of geo.pointsForts || []) out.push(itemText(p));
  for (const p of geo.pointsFaibles || []) out.push(itemText(p));
  for (const t of geo.todos || []) out.push(itemText(t));
  for (const a of geo.alertes || []) {
    out.push(itemText(a));
    if (a?.description) out.push(a.description);
  }
  return out.filter(Boolean);
}
